import { api as generatedApi } from './operations.generated';

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: ['CustomBranding', 'ClinicSetup'],
  endpoints: {
    getCustomBranding: {
      providesTags: ['CustomBranding'],
    },
    getCustomBrandingBySlug: {
      providesTags: (_result, _error, arg) => [
        { type: 'CustomBranding' as const, id: arg.input.slug },
      ],
    },
    upsertCustomBranding: {
      invalidatesTags: ['CustomBranding', 'ClinicSetup'],
    },
  },
});

export const {
  useUpsertCustomBrandingMutation,
  useGetCustomBrandingQuery,
  useLazyGetCustomBrandingQuery,
  useGetCustomBrandingBySlugQuery,
  useLazyGetCustomBrandingBySlugQuery,
} = api;
